import { makeStyles } from '@mui/styles';

const styles = makeStyles(theme => ({
  emptyHealthServiceCardHeight: {
    height: "400px"
  },
  marginTop: {
    marginTop: "20px"
  }
}));
export default styles;